<template>
  <div class="wrap min-h-100">
    <Loader :loading="isLoading" :text="$t('Loading product...')">
      <ProductItem
        :boards="boards"
        :interpretations="interpretations"
        :product="productData"
        :productStock="productStock"
        :products="board"
        :conditions="conditions"
      />
    </Loader>
  </div>
</template>

<script>
import { Loader } from '@/modules/core';
import { mapActions, mapGetters } from 'vuex';
import breadcrumbs from '@/modules/core/mixins/breadcrumbs';
import ProductItem from '../components/product/ProductItem.vue';

export default {
  name: 'Level4Product',
  mixins: [breadcrumbs],
  components: {
    ProductItem,
    Loader,
  },
  data() {
    return {
      isLoading: true,
      boards: this.$route.params.boards || [],
      interpretations: this.$route.params.interpretations,
      productData: this.product,
      productStock: this.product,
    };
  },
  created() {
    const grafikId = this.$route.query.hotspots;
    this.updateHotspots([]);
    this.routeBreadcrumbs(this.categoriesPath);
    const payload = {
      id: this.$route.params.product,
      vehicleSpecific: this.$route.query.vehicleSpecific || false,
    };
    this.fetchConditions(payload)
      .then(() => this.fetchProduct(this.$route.params.product))
      .then((product) => {
        this.productData = product;
        if (product.ProductType === 'GroupedProduct') {
          const promisses = [
            this.fetchBoard({ ...payload }),
            ...(() => (grafikId ? [this.fetchHotspots(grafikId)] : []))(),
          ];
          return Promise.all(promisses);
        }

        return this.fetchStock(product.Sku)
          .then((productWithStock) => {
            this.productStock = productWithStock;
          })
          .catch(() => {
            this.productStock = product;
          });
      })
      .finally(() => {
        this.pushBreadcrumbs({
          text: this.product.Name,
          link: `/level4/product/${this.$route.params.product}`,
        });
        this.isLoading = false;
      });
  },
  computed: {
    ...mapGetters({
      categoriesPath: 'level4/categoriesPath',
      conditions: 'level4/conditions',
      product: 'catalog/product',
      board: 'level4/board',
      filters: 'level4/filters',
    }),
  },
  methods: {
    ...mapActions({
      fetchConditions: 'level4/fetchConditions',
      fetchBoard: 'level4/fetchBoard',
      fetchProduct: 'catalog/fetchProduct',
      fetchHotspots: 'level4/fetchHotspots',
      fetchStock: 'level4/fetchStock',
      updateHotspots: 'level4/updateHotspots',
    }),
  },
};
</script>
